import { render } from "./BoxHistoricSearch.vue?vue&type=template&id=2256b592&scoped=true"
import script from "./BoxHistoricSearch.vue?vue&type=script&lang=js"
export * from "./BoxHistoricSearch.vue?vue&type=script&lang=js"

import "./BoxHistoricSearch.vue?vue&type=style&index=0&id=2256b592&lang=css"
import "./BoxHistoricSearch.vue?vue&type=style&index=1&id=2256b592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2256b592"]])

export default __exports__